// extracted by mini-css-extract-plugin
module.exports = {"main":"team-module--main--3zLhT","team":"team-module--team--3JbPu","footer":"team-module--footer--36JSP","text":"team-module--text--34WcS"};